// extracted by mini-css-extract-plugin
module.exports = {"root":"Review_root__sIvDV","moreButton":"Review_moreButton__XcC74"};